var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isQbDesktop)?_c('SyncWithConnectQuickBooksDesktop',{attrs:{"infoId":_vm.infoId,"isDialogOpen":_vm.isDialogOpen}}):_vm._e(),(_vm.isQbOnline)?_c('SyncWithConnectQuickBooksOnline',{attrs:{"infoId":_vm.infoId,"interfaceType":_vm.interfaceType,"isDialogOpen":_vm.isDialogOpen}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }